import { Collection } from 'modules/core/lib/mobx-rest'

import Application from 'modules/ats/store/models/Application'

class Applications extends Collection<Application> {
  get cacheKey(): string {
    return 'applications'
  }

  get indexes() {
    return ['ats_candidate_id', 'ats_application_phase_id', 'ats_job_posting_id']
  }

  model() {
    return Application
  }
}

const singleton: Applications = new Applications()

export default singleton
